/**
 * Strip HTML tags from a string
 */
export const stripHtmlTags = (html: string | null): string => {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent ?? '';
};

/**
 * Get the length of the plain text content of an HTML string
 */
export const getPlainTextLength = (html: string): number => {
  if (!html) return 0;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent?.trim().length ?? 0;
};

/**
 * Check if HTML content from TiptapEditor is effectively empty
 * TiptapEditor returns HTML strings like '<p></p>' or '<p><br></p>' when empty
 */
export const isEmptyHtmlContent = (
  html: string | null | undefined,
): boolean => {
  if (!html || html.trim() === '') {
    return true;
  }

  return getPlainTextLength(html) === 0;
};

/**
 * Normalize HTML content from TiptapEditor - returns null if empty, otherwise returns the HTML
 * Useful for form state management where empty content should be null
 */
export const normalizeHtmlContent = (
  html: string | null | undefined,
): string | null => {
  if (!html || html.trim() === '') {
    return null;
  }

  return getPlainTextLength(html) === 0 ? null : html;
};
